import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { isSingleLineListView } from 'owa-mail-layout';

const styles = require('./MessageAdListStubElement.scss');
const MessageAdListPreloadingStubElement = observer(
    function MessageAdListPreloadingStubElement(props: {}) {
        const useAdViewOneLine = isSingleLineListView();

        return (
            <div
                className={
                    useAdViewOneLine
                        ? styles.messageAdStaticContainerOneLine
                        : styles.messageAdStaticContainerThreeLine
                }
            />
        );
    }
);
export default MessageAdListPreloadingStubElement;
